import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_PUT, HTTP_DELETE, } from "../../tools/webservice";

export const getEmployeeAdminTimeLog = (employeeId, payPeriodId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/employee-admin-time-logs/employee/${employeeId}/pay-period/${payPeriodId}`,
  successCallback,
  mountedRef
});
export const addEmployeeAdminTimeLog = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/employee-admin-time-logs",
  payload,
  successCallback,
  mountedRef
});
export const deleteEmployeeAdminTimeLog = (timeLogId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/employee-admin-time-logs/${timeLogId}`,
  payload: {
    id: timeLogId,
  },
  successCallback,
  mountedRef
});
export const updateEmployeeAdminTimeLog = (payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/employee-admin-time-logs/${payload.id}`,
  payload,
  successCallback,
  mountedRef
});